import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(3)
    .required(),
  direccion: Yup.string()
    .min(3)
    .max(300)
    .required(),
  anexo: Yup.string()
    .length(4)
    .required(),
  ubigeo: Yup.string()
    .length(6)
    .required()
})
